import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.find-index.js";

/*
  This module implements shared 'Other Questions' features across questions.
  (E.g. Other Questions themselves, but also PR, CS etc etc)
*/
import { i18n } from "../../../boot/i18n";
import { FIB } from "../../../config/constants";
var QUESTION_FORMAT = FIB.QUESTION_FORMAT;
import { makeQuestionScreen, addSubmitQuestion } from "./_utils";
import { arrayify } from "../../../functions/utils";

function buildAnswer(context, text, choices) {
  return {
    text: text || null,
    choices: choices || [],
    mutateSubmit: function mutateSubmit(submit) {
      addSubmitQuestion(submit, context.response, {
        text: this.text,
        choices: this.choices
      });
    }
  };
}
/**
 * Get trigger answers for an Other Question-based type.
 */


export var getTriggerAnswers = function getTriggerAnswers(answer) {
  var _answer$value;

  var question = answer.meta.question;

  switch (question.otherQuestionsFormat) {
    case QUESTION_FORMAT.QUESTION_FORMAT_ONE_DROPDOWN:
    case QUESTION_FORMAT.QUESTION_FORMAT_ONE_RADIO:
    case QUESTION_FORMAT.QUESTION_FORMAT_ONE_CHECKBOX:
      {
        // Convert the values of the selected answers to their indexes within the question definition.
        var answers = arrayify(answer.value);
        return answers.map(function (v) {
          return question.otherQuestionsAnswers.findIndex(function (a) {
            return a === v;
          });
        }).filter(function (v) {
          return v >= 0;
        });
      }

    case QUESTION_FORMAT.QUESTION_FORMAT_YESNOWHY:
      // no === 0, yes === 1
      return [((_answer$value = answer.value) === null || _answer$value === void 0 ? void 0 : _answer$value.decision) === 'yes' ? 1 : 0];
  }

  return [];
};
export default {
  /**
   * Renders a Other Questions Screen.
   *
   * @param {Object} context
   *
   * @returns {Object} Screen model
   */
  render: function () {
    var _render = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(context) {
      var question, format, questionId, questionsAnswers, screenify;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              question = context.question; // get other question type - if not recognised, return null

              format = question ? question.otherQuestionsFormat : null;

              if (format) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return", null);

            case 4:
              // get answers
              questionId = 'question' + question.id;
              questionsAnswers = Array.isArray(question.otherQuestionsAnswers) ? question.otherQuestionsAnswers : [];

              screenify = function screenify(q) {
                return makeQuestionScreen(context, arrayify(q), question, {
                  title: q.title
                });
              };

              _context.t0 = format;
              _context.next = _context.t0 === QUESTION_FORMAT.QUESTION_FORMAT_ONE_DROPDOWN ? 10 : _context.t0 === QUESTION_FORMAT.QUESTION_FORMAT_ONE_RADIO ? 11 : _context.t0 === QUESTION_FORMAT.QUESTION_FORMAT_ONE_CHECKBOX ? 12 : _context.t0 === QUESTION_FORMAT.QUESTION_FORMAT_YESNOWHY ? 13 : _context.t0 === QUESTION_FORMAT.QUESTION_FORMAT_TEXT_SINGLE ? 14 : _context.t0 === QUESTION_FORMAT.QUESTION_FORMAT_TEXT_MULTIPLE ? 15 : 16;
              break;

            case 10:
              return _context.abrupt("return", screenify({
                id: questionId,
                type: 'fib-select',
                required: question.required,
                title: question.text,
                props: {
                  label: i18n.t('questions.common.dropdownPlaceholder'),
                  options: questionsAnswers.map(function (answer, j) {
                    return {
                      id: questionId + 'answer' + answer + j,
                      label: answer,
                      value: answer
                    };
                  })
                }
              }));

            case 11:
              return _context.abrupt("return", screenify({
                id: questionId,
                type: 'fib-select-option',
                required: question.required,
                title: question.text,
                props: {
                  center: true,
                  // if true, options should be centered
                  multiple: false,
                  // if true, multiple selection is enabled
                  options: questionsAnswers.map(function (answer, j) {
                    return {
                      id: questionId + 'answer' + answer + j,
                      label: answer,
                      val: answer
                    };
                  })
                }
              }));

            case 12:
              return _context.abrupt("return", screenify({
                id: questionId,
                type: 'fib-select-option',
                required: question.required,
                title: question.text,
                props: {
                  center: true,
                  // if true, options should be centered
                  multiple: true,
                  // if true, multiple selection is enabled
                  options: questionsAnswers.map(function (answer, j) {
                    return {
                      id: questionId + 'answer' + answer + j,
                      label: answer,
                      val: answer
                    };
                  })
                }
              }));

            case 13:
              return _context.abrupt("return", screenify({
                id: questionId,
                type: 'fib-yes-no',
                required: question.required,
                title: question.text,
                props: {
                  label: '',
                  noFollowUp: question.ynFollowupN,
                  yesFollowUp: question.ynFollowupY
                }
              }));

            case 14:
              return _context.abrupt("return", screenify({
                id: questionId,
                type: 'fib-comments',
                required: question.required,
                title: question.text,
                props: {
                  label: i18n.t('questions.comments.enter')
                }
              }));

            case 15:
              return _context.abrupt("return", screenify({
                id: questionId,
                type: 'fib-comments',
                required: question.required,
                title: question.text,
                props: {
                  label: i18n.t('questions.comments.enter'),
                  rows: 4 // Give textarea a minimum height of 4 rows

                }
              }));

            case 16:
              return _context.abrupt("return", null);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function render(_x) {
      return _render.apply(this, arguments);
    }

    return render;
  }(),

  /**
   * Parse a question answer
   *
   * @param {Object} context context
   * @param {Object} context.submit context.section
   * @param {Object} context.question context.question
   * @param {Object} context.response context.response
   */
  parseAnswer: function parseAnswer(context) {
    // we can always be assured that at least the first answers element exists, by construction -
    // i.e. how else would this question show up in the list of responses if we didn't have at least one answer for it?
    var value = context.response.answers[0].value;

    switch (context.question.otherQuestionsFormat) {
      case QUESTION_FORMAT.QUESTION_FORMAT_ONE_CHECKBOX:
      case QUESTION_FORMAT.QUESTION_FORMAT_ONE_DROPDOWN:
      case QUESTION_FORMAT.QUESTION_FORMAT_ONE_RADIO:
        {
          // convert all choices to an array (if not already), and remove nulls and blanks (but leave in valid 'empty looking' values like 0)
          var choices = arrayify(value).filter(function (c) {
            return c != null && c !== '';
          });
          return choices.length ? buildAnswer(context, null, choices) : null;
        }

      case QUESTION_FORMAT.QUESTION_FORMAT_TEXT_MULTIPLE:
      case QUESTION_FORMAT.QUESTION_FORMAT_TEXT_SINGLE:
        return value ? buildAnswer(context, value) : null;

      case QUESTION_FORMAT.QUESTION_FORMAT_YESNOWHY:
        return value ? buildAnswer(context, value.details || null, [value.decision.toLowerCase()]) : null;
    }
  }
};